"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestFactory = void 0;
// eslint-disable-next-line import/named
const ky_1 = __importDefault(require("ky"));
const react_1 = require("@stackworx/react");
const yup = __importStar(require("yup"));
const errorSchema = yup
    .object({
    error: yup.string().required(),
})
    .required();
function requestFactory(getToken, notify, options = {}) {
    return async function request(service, method, data) {
        const headers = {
            'content-type': 'application/octet-stream',
        };
        const token = await getToken();
        if (token) {
            headers['Authentication'] = `Bearer ${token}`;
        }
        const result = await ky_1.default.post(`${react_1.ConfigService.serverUri}/protobuf`, {
            searchParams: { service, method },
            headers,
            // Manually process non 2xx errors
            throwHttpErrors: false,
            body: data,
            retry: options.retry,
            timeout: options.timeout,
            hooks: options.hooks,
        });
        if (!result.body) {
            throw new Error('Missing response body');
        }
        if (result.ok) {
            const buffer = await result.arrayBuffer();
            return new Uint8Array(buffer, 0, buffer.byteLength);
        }
        const blob = await result.blob();
        const text = await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.addEventListener('loadend', (e) => {
                var _a;
                // @ts-expect-error @typescript-eslint/ban-ts-comment
                const text = (_a = e.srcElement) === null || _a === void 0 ? void 0 : _a.result;
                resolve(text);
            });
            reader.addEventListener('error', () => {
                reject(new Error('failed to read blob'));
            });
            // Start reading the blob as text.
            reader.readAsText(blob);
        });
        try {
            const data = JSON.parse(text);
            const errorJson = errorSchema.validateSync(data);
            throw new Error(errorJson.error);
        }
        catch (ex) {
            if (ex instanceof SyntaxError) {
                notify(new Error(`Could not parse error: ${text}`));
                throw new Error();
            }
            else {
                throw ex;
            }
        }
    };
}
exports.requestFactory = requestFactory;
